import React, { useState } from 'react';
import { keyframes, styled, useTheme } from '@mui/material';
import {
    Cell,
    Pie,
    PieChart,
    ResponsiveContainer,
} from 'recharts';
import { GraphDataPoint } from '../../interfaces/graphInterfaces';

const classesPrefix = 'donutGraph';

const classes = {
    loading: `${classesPrefix}-loading`,
};

// this is a duplicate of the 'MuiSkeleton-keyframes-pulse animation from MUI
const loadingKeyframe = keyframes`
0% { opacity: 1; }
50% { opacity: 0.4; }
100% { opacity: 1; }
`;

const StyledDiv = styled('div')(({ theme }) => {
    return {
        [`&.${classes.loading}`]: {
            background: `radial-gradient(circle, transparent 50%, ${theme.palette.grey[200]} 50%)`,
            borderRadius: '150px',
            height: '150px',
            width: '150px',
            animation: `${loadingKeyframe} 1.5s ease-in-out 0.5s infinite`,
        },
    };
});

const DonutGraph = ({
    loading,
    data,
}: {
    loading: boolean;
    data: GraphDataPoint[];
}): React.JSX.Element => {
    const theme = useTheme();

    const [activeIndex, setActiveIndex] = useState(0);

    const colors = theme.palette.dataVisualization[2];

    const onPieEnter = (pieData: any, index: any): void => {
        setActiveIndex(index);
    };

    if (loading) {
        return (
            <StyledDiv className={classes.loading} />
        );
    }

    return (
        <ResponsiveContainer height={150} width='100%' minWidth={150}>
            <PieChart>
                <Pie
                    activeIndex={activeIndex}
                    data={data}
                    innerRadius={50}
                    outerRadius={75}
                    startAngle={270}
                    endAngle={-90}
                    paddingAngle={1}
                    dataKey='value'
                    onMouseEnter={onPieEnter}
                >
                    {
                        data.map((entry, index): React.JSX.Element => {
                            return (<Cell key={`cell-${entry.name}`} fill={colors[index]} />);
                        })
                    }
                </Pie>
            </PieChart>
        </ResponsiveContainer>
    );
};

export default DonutGraph;
